import axios from 'axios';

import { ScopeSummary, ListResponse, ApiConfig, Scope } from '../types';
import { toSerializedError } from '../errors/utils';
import { PartialUpdateEntity } from '../types';

export type ListScopesResponse = ListResponse<ScopeSummary>;
export type ListScopeParams = {
  tenant_id: string;
};

export async function listScopes(
  { api_url, headers }: ApiConfig,
  { tenant_id }: ListScopeParams
) {
  try {
    let res = await axios.get<ListScopesResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/scopes', {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type CreateScopeParams = {
  tenant_id: string;
  body: Pick<Scope, 'name'|'title'|'description'>;
};
export type CreateScopeResponse = Pick<Scope, 'scope_id'> & {
  request_id: string;
};

export async function createScope(
  { api_url, headers }: ApiConfig,
  { tenant_id, body }: CreateScopeParams,
) {
  try {
    let res = await axios.post<CreateScopeResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/scopes', body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type GetScopeParams = {
  tenant_id: string;
  scope_name: string;
};
export type GetScopeResponse = Scope;

export async function getScope(
  { api_url, headers }: ApiConfig,
  { tenant_id, scope_name }: GetScopeParams,
) {
  try {
    let res = await axios.get<GetScopeResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/scopes/'+scope_name, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type UpdateScopeParams = {
  tenant_id: string;
  scope_name: string;
  body: PartialUpdateEntity<Pick<Scope, 'title'|'description'>>;
};
export type UpdateScopeResponse = {
  request_id: string;
};

export async function updateScope(
  { api_url, headers }: ApiConfig,
  { tenant_id, scope_name, body }: UpdateScopeParams,
) {
  try {
    let res = await axios.patch<UpdateScopeResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/scopes/'+scope_name, body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type DeleteScopeParams = {
  tenant_id: string;
  scope_name: string;
};
export type DeleteScopeResponse = {
  request_id: string;
};

export async function deleteScope(
  { api_url, headers }: ApiConfig,
  { tenant_id, scope_name }: DeleteScopeParams,
) {
  try {
    let res = await axios.delete<DeleteScopeResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/scopes/'+scope_name, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}
